import { useSelector } from "react-redux";
import { addAttractions, attractionsSelector } from "../Redux/appStateSlice";
import { WithFetchJsonContent } from "./WithFetchJsonContent";

export const WithAttractions = ({ children }) => {
  const allAttractions = useSelector(attractionsSelector);

  return (
    <WithFetchJsonContent reduxInStore={allAttractions} addToReduxFunction={addAttractions} jsonLocation="ATTRACTIONS">
      {children}
    </WithFetchJsonContent>
  );
};
